import { AnnouncementFilterBar } from "../../../Announcements/Table/AnnouncementFilterBar";
import { IGenericRequestParameters, InferSortByOptions, StringIndexedDict } from "../../../api/GenericTypes";
import { AttachmentsFilterbar } from "../../../Attachments/Table/AttachmentsFilterBar";
import { AuditLogFilterBar } from "../../../AuditLog/AuditLogFilterBar";
import { TabStoreFilterSidebarProps } from "../../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { CustomFieldsFilterBar } from "../../../Customization/CustomFields/Table/CustomFieldsFilterBar";
import { CustomTypesFilterBar } from "../../../Customization/CustomTypes/Table/CustomTypesFilterBar";
import { DatasetsFilterbar } from "../../../Dataset/Table/DatasetsFilterBar";
import { LabNotebookEntriesFilterBar } from "../../../ELN/LabNotebookEntries/Table/LabNotebookEntriesFilterBar";
import { LabNotebookExperimentFilterBar } from "../../../ELN/LabNotebookExperiments/Table/LabNotebookExperimentsFilterBar";
import { LabNotebookFilterBar } from "../../../ELN/LabNotebooks/Table/LabNotebooksFilterBar";
import { LabNotebookTemplateFilterBar } from "../../../ELN/LabNotebookTemplates/Table/LabNotebookTemplatesFilterBar";
import { InventoryItemsFilterBar } from "../../../Inventories/Table/InventoryItemsFilterBar";
import { MethodFilterBar } from "../../../Methods/Table/MethodFilterBar";
import { PersonFilterBar } from "../../../Persons/Table/PersonFilterBar";
import { ProjectFilterBar } from "../../../Projects/Table/ProjectFilterBar";
import { RoleFilterBar } from "../../../Roles/Table/RolesFilterBar";
import { SampleFilterBar } from "../../../samples/Table/SampleFilterBar";
import { GenericEntity, GenericEntityComponentProps } from "../GenericComponents";

export interface GenericEntityFilterFormProps<
  Entity extends GenericEntity & StringIndexedDict,
  Filters extends StringIndexedDict & IGenericRequestParameters<Entity, InferSortByOptions<Filters>>,
  FilterForm extends StringIndexedDict
> extends TabStoreFilterSidebarProps<Entity, FilterForm, Filters>,
    StringIndexedDict {}

export const GenericEntityFilterForm = <
  Entity extends GenericEntity & StringIndexedDict,
  Filters extends StringIndexedDict & IGenericRequestParameters<Entity, InferSortByOptions<Filters>>,
  FilterForm extends StringIndexedDict
>({
  entityTypeId,
  componentProps,
}: GenericEntityComponentProps<Entity, GenericEntityFilterFormProps<Entity, Filters, FilterForm>>) => {
  switch (entityTypeId) {
    case "announcements":
      return <AnnouncementFilterBar {...(componentProps as any)} />;
    case "attachments":
      return <AttachmentsFilterbar {...(componentProps as any)} />;
    case "auditLogs":
      return <AuditLogFilterBar {...(componentProps as any)} />;
    case "customFields":
      return <CustomFieldsFilterBar {...(componentProps as any)} />;
    case "customTypes":
      return <CustomTypesFilterBar {...(componentProps as any)} />;
    case "datasets":
      return <DatasetsFilterbar {...(componentProps as any)} />;
    case "inventoryItems":
      return <InventoryItemsFilterBar {...(componentProps as any)} />;
    case "methods":
      return <MethodFilterBar {...(componentProps as any)} />;
    case "notebookEntries":
      return <LabNotebookEntriesFilterBar {...(componentProps as any)} />;
    case "notebookExperiments":
      return <LabNotebookExperimentFilterBar {...(componentProps as any)} />;
    case "notebookTemplates":
      return <LabNotebookTemplateFilterBar {...(componentProps as any)} />;
    case "notebooks":
      return <LabNotebookFilterBar {...(componentProps as any)} />;
    case "persons":
      return <PersonFilterBar {...(componentProps as any)} />;
    case "projects":
      return <ProjectFilterBar {...(componentProps as any)} />;
    case "samples":
      return <SampleFilterBar {...(componentProps as any)} />;
    case "roles":
      return <RoleFilterBar {...(componentProps as any)} />;
    default:
      return null;
  }
};
